import './vds-aspect-ratio';
import './vds-fullscreen-button';
import './vds-gesture';
import './vds-mute-button';
import './vds-play-button';
import './vds-poster';
import './vds-slider-value-text';
import './vds-slider-video';
import './vds-slider';
import './vds-time-slider';
import './vds-time';
import './vds-toggle-button';
import './vds-volume-slider';
